"use client";

import { useEffect } from 'react';

export function ThemeHydrationFix() {
  useEffect(() => {
    // Apply theme immediately on client side to prevent hydration mismatch
    const savedTheme = localStorage.getItem('abbi_theme') as 'light' | 'dark' | 'system' || 'dark';
    const actualTheme = savedTheme === 'system' ? 
      (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light') : 
      savedTheme;
    
    // Apply theme to body immediately
    document.body.setAttribute('data-theme', actualTheme);
  }, []);

  return null;
}





